export const SET_APPLICANT_LISTS = 'SET_APPLICANT_LISTS';
export const SET_BULK_APPLICANT_LISTS = 'SET_BULK_APPLICANT_LISTS';
export const RESET_APPLICANT_LISTS = 'RESET_APPLICANT_LISTS';
